import { render, staticRenderFns } from "./sendDialog.vue?vue&type=template&id=045b5bb0&"
import script from "./sendDialog.vue?vue&type=script&lang=js&"
export * from "./sendDialog.vue?vue&type=script&lang=js&"
import style0 from "./sendDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports